import { AdminPageHeader } from "@admin-ui/components/composed/AdminPageHeader";
import { AdminLayout } from "@admin-ui/components/frames/AdminLayout";
import { Head, router } from "@inertiajs/react";
import { adminWorldAdoptionPath, adminWorldSourceIngestionsPath, adminWorldSourcesPath } from "@travily/routes";
import type AdminWorldSourcesIndex from "@travily/types/pages/AdminWorldSourcesIndex";
import { type ReactNode, useCallback } from "react";
import { useAdminLayoutAccount } from "@/hooks/admin/use-admin-layout-account";
import AdminPersistentLayout from "@/layouts/admin-persistent-layout";
import { IndexView } from "./index.view";

function AdminWorldSourcesIndexPage({ sources, shadow_totals, backtest }: AdminWorldSourcesIndex) {
  const account = useAdminLayoutAccount();

  const handleIngest = useCallback(
    (sourceKey: string) =>
      router.post(adminWorldSourceIngestionsPath(), { source_key: sourceKey }, { preserveScroll: true }),
    [],
  );

  const handleAdopt = useCallback(
    (destinationId: number) => router.post(adminWorldAdoptionPath(destinationId), {}, { preserveScroll: true }),
    [],
  );

  return (
    <AdminLayout activeUrl={adminWorldSourcesPath()} account={account}>
      <Head title="Knowledge sources - Admin" />

      <AdminPageHeader
        breadcrumbs={[]}
        title="Knowledge sources"
        subtitle="Every source the world layer is allowed to believe, what we owe it, and when it last said anything"
      />

      <div className="mx-auto flex w-full max-w-container flex-col gap-6 px-4 lg:gap-8 lg:px-8">
        <IndexView
          sources={sources}
          shadowTotals={shadow_totals}
          backtest={backtest}
          onIngest={handleIngest}
          onAdopt={handleAdopt}
        />
      </div>
    </AdminLayout>
  );
}

AdminWorldSourcesIndexPage.layout = (page: ReactNode) => <AdminPersistentLayout>{page}</AdminPersistentLayout>;

export default AdminWorldSourcesIndexPage;
